/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FeesModel = {
    AccountNumber?: string;
    Description?: string;
    Amount?: number;
    CollectionDate?: string;
    PaidDate?: string | null;
    FeePayorType?: FeesModel.FeePayorType;
};
export namespace FeesModel {
    export enum FeePayorType {
        INVESTOR = 'Investor',
        AGENT = 'Agent',
        SPONSOR = 'Sponsor',
    }
}

